import Vue from 'vue';
import _ from 'lodash';
import { createActionHelpers } from 'vuex-loading';
import operationService from '@/features/operation/service';


const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

export const UPDATE_ERROR = 'UPDATE_ERROR';
export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_OPERATION = 'UPDATE_OPERATION';
export const INIT_NEEDED_DOCUMENT = 'INIT_NEEDED_DOCUMENT';
export const ADD_NEEDED_DOCUMENT = 'ADD_NEEDED_DOCUMENT';
export const UPDATE_NEEDED_DOCUMENT = 'UPDATE_NEEDED_DOCUMENT';
export const DELETE_NEEDED_DOCUMENT = 'DELETE_NEEDED_DOCUMENT';

export const initModuleAction = 'initModuleAction';
export const removeNeededDocumentAction = 'removeNeededDocumentAction';
export const saveNeededDocumentAction = 'saveNeededDocumentAction';
export const updateOperationAction = 'updateOperationAction';

function initState() {
  return {
    error: '',
    documentsNeeded: [],
    documentsNeededData: {},
    operation: null,
  };
}

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    [UPDATE_OPERATION](state, payload) {
      Vue.set(state, 'operation', payload);
    },
    [UPDATE_ERROR](state, payload) {
      Vue.set(state, 'error', payload);
    },
    [CLEAR_MODULE](state) {
      Vue.set(state, 'error', '');
      Vue.set(state, 'documentsNeeded', []);
      Vue.set(state, 'documentsNeededData', {});
    },
    [INIT_NEEDED_DOCUMENT](state, payload) {
      if (Array.isArray(payload)) {
        let i = 0;
        payload.forEach((doc) => {
          Vue.set(state.documentsNeeded, i, doc.id);
          Vue.set(state.documentsNeededData, doc.id, doc);
          i += 1;
        });
      }
    },
    [ADD_NEEDED_DOCUMENT](state, payload) {
      state.documentsNeeded.push(payload.id);
      Vue.set(state.documentsNeededData, payload.id, payload);
    },
    [UPDATE_NEEDED_DOCUMENT](state, payload) {
      const { documentNeeded, index } = payload;
      if (index > -1 && index < state.documentsNeeded.length) {
        Vue.set(state.documentsNeeded, index, documentNeeded.id);
        Vue.set(state.documentsNeededData, documentNeeded.id, documentNeeded);
      }
    },
    [DELETE_NEEDED_DOCUMENT](state, payload) {
      const index = state.documentsNeeded.indexOf(payload.id);
      if (index > -1) {
        state.documentsNeeded.splice(index, 1);
        Vue.delete(state.documentsNeededData, payload.id);
      }
    },
  },
  actions: {
    async [initModuleAction]({ commit, rootGetters, dispatch }, operationId) {
      startLoading(dispatch, 'juridico');
      commit(CLEAR_MODULE);
      await dispatch('collaborator/initModuleAction', operationId, { root: true });
      await dispatch('propuestano/initModuleAction', operationId, { root: true });
      endLoading(dispatch, 'juridico');
    },
    async [saveNeededDocumentAction]({ commit, dispatch, rootGetters }, payload) {
      const { document, operation } = payload;
      const savedDocument = await dispatch('document_model/upsertEntityAction', document, { root: true });
      const newDocumentsNeeded = Array.isArray(operation.documentsNeeded) ? operation.documentsNeeded : [];
      if (newDocumentsNeeded.indexOf(savedDocument.id) === -1) {
        newDocumentsNeeded.push(savedDocument.id);
        const newOperation = Object.assign({}, operation, { documentsNeeded: newDocumentsNeeded });
        const savedOperation = await dispatch('operation_model/upsertEntityAction', newOperation, { root: true });
        commit(UPDATE_OPERATION, savedOperation);
      }
      return savedDocument;
    },
    async [removeNeededDocumentAction]({ commit, dispatch }, payload) {
      const { document, operation } = payload;
      let newDocumentsNeeded = Array.isArray(operation.documentsNeeded) ? operation.documentsNeeded : [];
      newDocumentsNeeded = newDocumentsNeeded.filter(d => d !== document.id);
      const newOperation = Object.assign({}, operation, { documentsNeeded: newDocumentsNeeded });
      const savedOperation = await dispatch('operation_model/upsertEntityAction', newOperation, { root: true });
      commit(UPDATE_OPERATION, savedOperation);
    },
    [updateOperationAction]({ state, rootGetters }) {
      const id = rootGetters['operation/operation'].id;
      const operation = {
        id,
        documentsNeeded: state.documentsNeeded,
      };
      return operationService.updateOperation(operation);
    },
  },
  getters: {
    selectedOperation: state => state.operation,
    documentsNeededIds: state => (state.operation && Array.isArray(state.operation.documentsNeeded) ? state.operation.documentsNeeded : []),
    documentsNeeded: (state, getters, rootState, rootGetters) => {
      const documents = rootGetters['document_model/entitiesGetter'];
      if (!_.isEmpty(documents)) {
        const ids = getters.documentsNeededIds;
        return ids.map(id => documents[id]);
      }
      return [];
    },
  },
};



// WEBPACK FOOTER //
// ./src/features/juridico/store.js